export const SESSION_DISPLAY_STATUS = Object.freeze({
  VOICE_ONGOING: "voice_ongoing",
  VOICE_VOICEMAIL_LEFT: "voice_voicemail_left",
  VOICE_COMPLETED: "voice_completed",
  VOICE_FAILED: "voice_failed",
  TEXT_ONGOING: "text_ongoing",
  TEXT_COMPLETED: "text_completed",
  TEXT_FAILED: "text_failed",
  CHAT: "chat",
  UNKNOWN: "unknown",
});

export const SESSION_DISPLAY_STATUS_OPTIONS = [
  { label: "Voice: Call ongoing", value: SESSION_DISPLAY_STATUS.VOICE_ONGOING },
  {
    label: "Voice: Voicemail left",
    value: SESSION_DISPLAY_STATUS.VOICE_VOICEMAIL_LEFT,
  },
  {
    label: "Voice: Call completed",
    value: SESSION_DISPLAY_STATUS.VOICE_COMPLETED,
  },
  { label: "Voice: Call failed", value: SESSION_DISPLAY_STATUS.VOICE_FAILED },
  { label: "Text: Texting ongoing", value: SESSION_DISPLAY_STATUS.TEXT_ONGOING },
  {
    label: "Text: Texting completed",
    value: SESSION_DISPLAY_STATUS.TEXT_COMPLETED,
  },
  {
    label: "Text: Text sending failed",
    value: SESSION_DISPLAY_STATUS.TEXT_FAILED,
  },
  { label: "Other: Unknown status", value: SESSION_DISPLAY_STATUS.UNKNOWN },
];

const CALL_STATUS = {
  success: ["completed"],
  failed: ["busy", "canceled", "failed", "no-answer", "error"],
};

export const getSessionDisplayStatus = (header) => {
  switch (header.modality) {
    case "voice":
      if (!header.ended_at) {
        return SESSION_DISPLAY_STATUS.VOICE_ONGOING;
      }
      if (!header.voice_statistic) {
        return SESSION_DISPLAY_STATUS.VOICE_FAILED;
      }
      if (header.voice_statistic?.voicemail_reached) {
        return SESSION_DISPLAY_STATUS.VOICE_VOICEMAIL_LEFT;
      }
      if (
        CALL_STATUS.success.includes(header.voice_statistic?.final_call_status)
      ) {
        return SESSION_DISPLAY_STATUS.VOICE_COMPLETED;
      }
      if (
        CALL_STATUS.failed.includes(header.voice_statistic?.final_call_status)
      ) {
        return SESSION_DISPLAY_STATUS.VOICE_FAILED;
      }
      return SESSION_DISPLAY_STATUS.UNKNOWN;

    case "text":
      if (!header.ended_at) {
        return SESSION_DISPLAY_STATUS.TEXT_ONGOING;
      }
      if (header.latest_text_at) {
        return SESSION_DISPLAY_STATUS.TEXT_COMPLETED;
      }
      return SESSION_DISPLAY_STATUS.TEXT_FAILED;

    case "chat":
      return SESSION_DISPLAY_STATUS.CHAT;

    default:
      return SESSION_DISPLAY_STATUS.UNKNOWN;
  }
};